<template>
  <BaseModal
    v-if="modalIsOpen"
    :title="$t(`shafts.group.add_new_group`)"
    :actions="true"
    @dismissModal="closeModal"
    :modifiers="['flat-title', 'no-padding-x']"
  >
    <template #content>
      <div class="form form--lighter form--no-peek">
        <div class="form__group">
          <FormRow
            :label="$t('shafts.group.group_title')"
            labelFor="new_group_name"
            :modifiers="['no-padding']"
            :errors="errors && errors.shaft_element_group.name"
          >
            <div class="form-row__input form-row__input--no-peek">
              <div :class="{ input: true, 'input--error': errors && errors.shaft_element_group.name }">
                <input id="new_group_name" v-model="elementName" />
              </div>
            </div>
          </FormRow>
        </div>
      </div>
    </template>
    <template #actions>
      <FormSubmitButton
        @click="saveGroup"
        :buttonLabel="submitButtonText"
        :isSaving="saving"
      />
    </template>
  </BaseModal>
</template>

<script setup>
import { computed, ref } from 'vue';
import { useRoute } from 'vue-router';
import I18n from 'i18n-js';

// Components
import BaseModal from '@/components/generic/base_modal.vue';
import FormRow from '@/components/form/row.vue';
import FormSubmitButton from '@/components/form/form_submit_button.vue';

// Assets
import useAjax from '@/functions/use_ajax';

const props = defineProps({
  elementType: { type: String, required: true },
  modalIsOpen: Boolean,
});
const emit = defineEmits(['save', 'update:modalIsOpen']);

const ajax = useAjax();
const route = useRoute();

const elementName = ref(null);
const saving = ref(false);
const errors = ref(null);

const submitButtonText = computed(() => {
  return I18n.t('general.save');
});

function closeModal() {
  elementName.value = null;
  emit('update:modalIsOpen', false);
}

async function saveGroup() {
  saving.value = true;
  errors.value = null;
  let path, method;

  if (props.elementType) {
    path = `/organisations/${route.params.organisationId}/shafts/${route.params.shaftId}/shaft_element_groups`;
    method = 'POST';
  }

  let { ok, data } = await ajax(path, {
    method,
    body: {
      shaft_element_group: {
        name: elementName.value,
        element_type: props.elementType
      }
    },
  });

  if (ok) {
    elementName.value = null;
    emit('update:modalIsOpen', false);
    emit('save', data);

  } else {
    errors.value = data;
  }
  saving.value = false;
}
</script>
